// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3aeRC","label":"CategoryService_label__3-jFA","location":"CategoryService_location__zBAic"};